export class DocumentAttribute {
    typeId: string;
    typeCode: string;
    attributeId: string;
    value: any;
    displayValue?: string;
    code?: string;
    name?: string;

    constructor() {
    }
  }
